import { Field } from './Field';

export class ColorPickerField extends Field {
  type = 'color-picker'
  public render(): HTMLElement {
    const container = this.createContainer();
    const input = document.createElement('input');
    input.type = 'color';
    input.id = this.name;
    input.name = this.name;
    input.value = this.value;
    input.addEventListener('input', (event) => {
      const target = event.target as HTMLInputElement;
      this.onChange(target.value);
    });
    container.appendChild(input);

    return container;
  }
}
